import request from '@/utils/request'

//转账记录
export function withdrawTransferList(data) {
    return request({
      url: '/admin/withdrawTransfer/list',
      method: 'post',
      data: data
    })
  }
  export function totalRecharge(data) {
    return request({
      url: '/admin/tronscanTransfer/totalRecharge',
      method: 'post',
      data: data
    })
  }
  export function tronscanTransferList(data) {
    return request({
      url: '/admin/tronscanTransfer/list',
      method: 'post',
      data: data
    })
  }
// 归集账号管理
export function tronscanMasterAccountList(data) {
  return request({
    url: '/admin/tronscanMasterAccount/list',
    method: 'post',
    data: data
  })
}
export function tronscanMasterAccountDelete(data) {
  return request({
    url: '/admin/tronscanMasterAccount/delete',
    method: 'post',
    data: data
  })
}
export function tronscanMasterAccountSave(data) {
  return request({
    url: '/admin/tronscanMasterAccount/save',
    method: 'post',
    data: data
  })
}
export function tronscanMasterAccountUpdate(data) {
  return request({
    url: '/admin/tronscanMasterAccount/update',
    method: 'post',
    data: data
  })
}
export function getById(data) {
  return request({
    url: '/admin/tronscanMasterAccount/getById',
    method: 'post',
    data: data
  })
}
export function genNew(data) {
  return request({
    url: '/admin/tronscanMasterAccount/genNew',
    method: 'post',
    data: data
  })
}
export function importWallet(data) {
  return request({
    url: '/admin/tronscanMasterAccount/importWallet',
    method: 'post',
    data: data
  })
}

// 归集记录
export function tronscanCollectionList(data) {
    return request({
      url: '/admin/tronscanCollection/list',
      method: 'post',
      data: data
    })
  }
  export function totalAmount(data) {
    return request({
      url: '/admin/tronscanCollection/totalAmount',
      method: 'post',
      data: data
    })
  }
// 提现转账
export function withdrawTransfer(data) {
    return request({
      url: '/admin/withdrawTransfer/list',
      method: 'post',
      data: data
    })
  }
  export function autoZhuan(data) {
    return request({
      url: '/admin/withdrawTransfer/autoZhuan',
      method: 'post',
      data: data
    })
  }
  export function updateAutoZhuan(data) {
    return request({
      url: '/admin/withdrawTransfer/updateAutoZhuan',
      method: 'post',
      data: data
    })
  }
  export function zhuan(data) {
    return request({
      url: '/admin/withdrawTransfer/zhuan',
      method: 'post',
      data: data
    })
  }
  export function reject(data) {
    return request({
      url: '/admin/withdrawTransfer/reject',
      method: 'post',
      data: data
    })
  }
  export function zhuanList(data) {
    return request({
      url: '/admin/withdrawTransfer/zhuanList',
      method: 'post',
      data: data
    })
  }
  export function masterAccounts(data) {
    return request({
      url: '/admin/withdrawTransfer/masterAccounts',
      method: 'post',
      data: data
    })
  }
  export function applyCount(data) {
    return request({
      url: '/admin/withdrawTransfer/applyCount',
      method: 'post',
      data: data
    })
  }
  // 用户资金管理
  export function masterAccountsT(data) {
    return request({
      url: '/admin/memberCollection/masterAccounts',
      method: 'post',
      data: data
    })
  }
  export function collect(data) {
    return request({
      url: '/admin/memberCollection/collect',
      method: 'post',
      data: data
    })
  }
  export function zhuanTrx(data) {
    return request({
      url: '/admin/memberCollection/zhuanTrx',
      method: 'post',
      data: data
    })
  }
  export function collectTrx(data) {
    return request({
      url: '/admin/memberCollection/collectTrx',
      method: 'post',
      data: data
    })
  }
  export function delegatedEnergy(data) {
    return request({
      url: '/admin/memberCollection/delegatedEnergy',
      method: 'post',
      data: data
    })
  }
  export function undelegateResource(data) {
    return request({
      url: '/admin/memberCollection/undelegateResource',
      method: 'post',
      data: data
    })
  }
  export function oneCollect(data) {
    return request({
      url: '/admin/memberCollection/oneCollect',
      method: 'post',
      data: data
    })
  }
  export function collectView(data) {
    return request({
      url: '/admin/memberCollection/collectView',
      method: 'post',
      data: data
    })
  }
  export function collectList(data) {
    return request({
      url: '/admin/memberCollection/collectList',
      method: 'post',
      data: data
    })
  }
  export function collectListRemove(data) {
    return request({
      url: '/admin/memberCollection/collectListRemove',
      method: 'post',
      data: data
    })
  }
  export function memberCollectionList(data) {
    return request({
      url: '/admin/memberCollection/list',
      method: 'post',
      data: data
    })
  }

  export function memberPayAdList(data) {
    return request({
      url: '/admin/memberPayAd/list',
      method: 'post',
      data: data
    })
  }
  export function memberPayAdPass(data) {
    return request({
      url: '/admin/memberPayAd/pass',
      method: 'post',
      data: data
    })
  }
  export function memberPayAdReject(data) {
    return request({
      url: '/admin/memberPayAd/reject',
      method: 'post',
      data: data
    })
  }
   export function withdrawTransferResetStatus(data) {
    return request({
      url: '/admin/withdrawTransfer/resetStatus',
      method: 'post',
      data: data
    })
  }
  export function withdrawTransferTotalAmount(data) {
    return request({
      url: '/admin/withdrawTransfer/totalAmount',
      method: 'post',
      data: data
    })
  }
  export function tronscanZhuanTotalAmount(data) {
    return request({
      url: '/admin/tronscanZhuan/totalAmount',
      method: 'post',
      data: data
    })
  }
  export function tronscanZhuanList(data) {
    return request({
      url: '/admin/tronscanZhuan/list',
      method: 'post',
      data: data
    })
  }
  export function tronscanZhuanExport(data) {
    return request({
      url: '/admin/tronscanZhuan/export',
      method: 'post',
      data: data
    })
  }
  export function batchFreshUSDT(data) {
    return request({
      url: '/admin/memberCollection/batchFreshUSDT',
      method: 'post',
      data
    })
  }
  export function freshUSDT(data) {
    return request({
      url: '/admin/memberCollection/freshUSDT',
      method: 'post',
      data
    })
  }
  // TRX提现转账
  export function listTex(data) {
    return request({
      url: '/admin/withdrawTransferTrx/list',
      method: 'post',
      data
    })
  }
  export function totalAmountTex(data) {
    return request({
      url: '/admin/withdrawTransferTrx/totalAmount',
      method: 'post',
      data
    })
  }
  export function applyCountTex(data) {
    return request({
      url: '/admin/withdrawTransferTrx/applyCount',
      method: 'post',
      data
    })
  }
  export function updateAutoZhuanTex(data) {
    return request({
      url: '/admin/withdrawTransferTrx/updateAutoZhuan',
      method: 'post',
      data
    })
  }
  export function zhuanTex(data) {
    return request({
      url: '/admin/withdrawTransferTrx/zhuan',
      method: 'post',
      data
    })
  }
  export function rejectTex(data) {
    return request({
      url: '/admin/withdrawTransferTrx/reject',
      method: 'post',
      data
    })
  }
  export function zhuanListTex(data) {
    return request({
      url: '/admin/withdrawTransferTrx/zhuanList',
      method: 'post',
      data
    })
  }
  export function masterAccountsTex(data) {
    return request({
      url: '/admin/withdrawTransferTrx/masterAccounts',
      method: 'post',
      data
    })
  }
  export function autoZhuanTex(data) {
    return request({
      url: '/admin/withdrawTransferTrx/autoZhuan',
      method: 'post',
      data
    })
  }
  // TRX转账记录
  export function tronscanZhuanWithdrawTrxList(data) {
    return request({
      url: '/admin/tronscanZhuanWithdrawTrx/list',
      method: 'post',
      data
    })
  }
  export function tronscanZhuanWithdrawTrxTotalAmount(data) {
    return request({
      url: '/admin/tronscanZhuanWithdrawTrx/totalAmount',
      method: 'post',
      data
    })
  }
  export function tronscanZhuanWithdrawTrxExport(data) {
    return request({
      url: '/admin/tronscanZhuanWithdrawTrx/export',
      method: 'post',
      data
    })
  }
  